import { ActionIconButton, TableColumnHeader } from "@/components/shared/table/Table";
import { User } from "@/graphql/__generated__/graphql";
import { isManager, isMemberOfMainOrganization } from "@/utils/authentication";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { TrashIcon } from "lucide-react";
import { IntlShape } from "react-intl";

export const getColumns = (intl: IntlShape, t: TFunction, userId: number, actionFn?: any): ColumnDef<User, string>[] => {
  return [
    {
      accessorKey: "firstname",
      header: ({ column }) => <TableColumnHeader hideSortingButton={true} text={t("tables:users.columns.firstname")} column={column} />,
      cell: ({ row }) => row.original.firstname,
    },
    {
      accessorKey: "lastname",
      header: ({ column }) => <TableColumnHeader hideSortingButton={true} text={t("tables:users.columns.lastname")} column={column} />,
      cell: ({ row }) => row.original.lastname,
    },
    {
      accessorKey: "organization.name",
      header: ({ column }) => <TableColumnHeader hideSortingButton={true} text={t("tables:users.columns.organization")} column={column} />,
      cell: ({ row }) => row.original.organization.name,
    },
    (isMemberOfMainOrganization() && isManager()) ?
      {
        id: "actionsRemove",
        cell: ({ row }) => (userId !== row.original.id) ? (
          <div className="flex items-center justify-end">
            <ActionIconButton
              dataObj={row.original}
              fn={() => actionFn(row.original.id)}
              tooltipText={t("common:buttons.remove")}
              variant="destructive"
            >
              <TrashIcon className="h-4 w-4" />
            </ActionIconButton>
          </div>
        ) : undefined,
      }: undefined
  ].filter(Boolean) as ColumnDef<User, string>[];
};
